import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import Api from '#services/api'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'
import Headline from '#components/a/Headline'
import FeedbackVorlage from '#components/svg/icons/FeedbackVorlage'
import Text from '#components/a/Text'
import FeedbackDownloadButton from '#components/m/Feedback/FeedbackDownloadButton'

function FeedbackVorlagenItem({name, path}) {
  const downloadFile = async () => {
    await Api.getFeedbackVorlagenFile(path, name)
  }

  return (
    <li>
      <div data-testid="feedback-vorlage" className="feedback-vorlagen--item">
        <div className="feedback-vorlagen--file">
          <FeedbackVorlage />
          <TriggerWithTooltip text={name} modifiers={['dark', 'nopadding']}>
            <span>{name}</span>
          </TriggerWithTooltip>
        </div>
        <FeedbackDownloadButton downloadFile={downloadFile} />
      </div>
    </li>
  )
}

FeedbackVorlagenItem.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
}

function FeedbackVorlagenOverview() {
  const [feedbackVorlagen, setFeedbackVorlagen] = useState([])

  useEffect(() => {
    const execute = async () => {
      try {
        const result = await Api.getFeedbackVorlagen()
        setFeedbackVorlagen(result)
      } catch (e) {
        actions.error.writeError({error: e})
      }
    }
    execute()
  }, [])

  const hasVorlagen = feedbackVorlagen?.length > 0

  return (
    <div className="feedback--vorlagen">
      <Headline importance={2} modifier="category" text={i18n.t('feedback_vorlagen_overview')} />
      {hasVorlagen ? (
        <ul>
          {feedbackVorlagen.map(vorlage => (
            <FeedbackVorlagenItem key={vorlage.path} name={vorlage.name} path={vorlage.path} />
          ))}
        </ul>
      ) : (
        <Text text={i18n.t('feedback_vorlagen_empty_text')} />
      )}
    </div>
  )
}

export default FeedbackVorlagenOverview
